import { Box, Button, Grid, Link, Typography } from "@mui/material";
import logo from "assets/logos/logo-transparent.png";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UpgradeDialogSource } from "schemas/dashboard";
import { routes } from "schemas/routes";

import { PAGE_VISITED } from "constants/trackingProps";
import { getParams, getSource, trackEvent } from "utils/tracking";

import SplashPageHome from "../components/Home";
import styles from "./styles";

const AnnualTemplate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentOrg } = useContext(OrganizationUserContext);
  const fromRoutes = `${routes.annualTemplate}`;

  const isSignedIn = getParams("signed_in") === "true";

  const clickGo = async () => {
    trackEvent("Splash Page - Checkout Button Clicked", {
      source: getSource(),
      routes: fromRoutes,
    });
    if (currentOrg?.id) {
      displayAnnualPlan();
    } else {
      navigate(`/${fromRoutes}/sign-up${location.search}`);
    }
  };

  const displayAnnualPlan = () => {
    let url = `/${routes.home}${location.search}`;
    if (url?.includes("?")) {
      url += `&upgradeDialogSource=${encodeURIComponent(UpgradeDialogSource.splash_page_annual_template)}`;
    } else {
      url += `?upgradeDialogSource=${encodeURIComponent(UpgradeDialogSource.splash_page_annual_template)}`;
    }
    navigate(url);
  };

  useEffect(() => {
    trackEvent(PAGE_VISITED);
    if (isSignedIn && currentOrg?.id) {
      displayAnnualPlan();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn, currentOrg?.id]);
  return (
    <SplashPageHome
      checkOutForSplashPage={displayAnnualPlan}
      backgroundColor="#b1b3f7"
      planDetails={
        <>
          <Link
            href={"https://onbento.com?s=annual_template"}
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <Box
              component="img"
              src={logo}
              alt="Bento Logo"
              sx={{ width: 80, mb: 2 }}
            />
          </Link>
          <Typography
            gutterBottom
            variant="h2"
            sx={{ color: "white", "-webkit-text-stroke": "1px #7d7e94" }}
          >
            Get a brand-ready pitch that helps you land paid deals
          </Typography>
          <Typography variant="h6" sx={{ fontFamily: "Afacad", fontSize: 20 }}>
            Get a{" "}
            <strong>
              <u>human written</u>
            </strong>{" "}
            pitch template when you start an annual Bento plan.
          </Typography>

          <Typography sx={{ fontSize: 18, fontFamily: "Afacad" }}>
            👉 Stop guessing what brands want to hear <br />
            👉 Tailored to you <br />
            👉 Reusable across brands <br />✅ Proven to get 4x response rates
          </Typography>

          <Grid container justifyContent="center">
            <Box sx={styles.editor}>
              <Typography
                sx={{ color: "purple.main", fontSize: 14, fontWeight: 600 }}
                gutterBottom
              >
                Your pitch is ready to review:{" "}
              </Typography>

              <Box sx={styles.whiteBg}>
                Hi{" "}
                <Box component="span" sx={styles.mergeTag}>
                  &#123;First Name&#125;
                </Box>{" "}
                ! <br />
                I'm a UGC creator who just moved to NYC and I can't believe how
                much I've been hearing about{" "}
                <Box component="span" sx={styles.mergeTag}>
                  &#123;Brand Name&#125;
                </Box>
                !! <br />
                <br />
                I've just partnered with SKIMS to create Instagram ads. Here's a{" "}
                <Box component="span" sx={{ color: "info.main" }}>
                  link
                </Box>{" "}
                (Hailey Beiber liked it!) 🤯
              </Box>
            </Box>
          </Grid>

          <Grid
            container
            justifyContent={"center"}
            flexDirection={"column"}
            alignItems={"center"}
          >
            <Button sx={styles.claimFree} onClick={clickGo} variant="contained">
              Claim Free Pitch{" "}
              <Box
                sx={{ ml: 1 }}
                component="i"
                className="fa-regular fa-arrow-right"
              />
            </Button>
            <Typography
              sx={{ color: "white", fontSize: 16, mt: 1, fontFamily: "Afacad" }}
            >
              Included with an annual Bento plan, view pricing next
            </Typography>

            <Typography
              textAlign={"center"}
              sx={{ mt: 3, fontFamily: "Afacad", fontSize: 18 }}
            >
              What's Bento? A pitching tool for content creators to land more
              deals.{" "}
              <Link
                href={"https://onbento.com?s=annual_template"}
                target="_blank"
                sx={{ textDecoration: "none", fontWeight: 700 }}
              >
                Learn more
              </Link>
            </Typography>
          </Grid>
        </>
      }
      fromRoutes={`${routes.annualTemplate}`}
      notQualified={false}
    />
  );
};

export default AnnualTemplate;
